import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { datePickerValidator } from '@app/core/Directives/datepicker-validator';
import {
  MaxLength,
  ModuleName,
  Modules,
  NotificationTextMessage,
} from '@app/core/Enum';
import { GlobalComponent, GroupListModel } from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import { HighlightRow } from '@app/core/Services/common/highlighted-texts.service';
import {
  CreateFund,
  FundTransferState,
  GetDataByFundId,
  GetFundNameList,
  GetFundsByBankID,
  GetGroupCustomBankAndCashAccount,
  GetTransferToFund,
} from '@app/core/Store';
import { QuickAddComponent } from '@app/modules';
import { Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { Observable, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-add-bank-transfer',
  templateUrl: './add-bank-transfer.component.html',
  styleUrls: ['./add-bank-transfer.component.scss'],
})
export class AddBankTransferComponent implements OnInit {
  bankTransferForm: FormGroup;
  maxLength = MaxLength;

  fundNameList: any;
  tofundNameList: any;
  transferToGroupList: any;
  transferFromGroupList: any;
  periodicDate: any;

  @Input() triggerTransactionLogData: Observable<any>;
  @Input() triggerEditData: Observable<any>;
  @Input() isPeriodLocked : any;
  notificationMessage = NotificationTextMessage;
  tempGroupList: GroupListModel[];

  disabledFundEditButton = true;

  private destroy$ = new Subject<void>();

  isBankImport = false;
  isCredit = false;

  minInvoiceDate: Date;
  maxInvoiceDate: Date = new Date();
  
  constructor(
    public commonService: CommonService,
    public highlightRow: HighlightRow,
    private globalComponent: GlobalComponent,
    private store: Store,
    private renderer: Renderer2,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.periodicDate = this.globalComponent.getFinancialPeriod();
    this.setForm();

    if (this.isPeriodLocked) {
      this.bankTransferForm.disable();
    }
    this.bankTransferForm.get('transferFrom')?.valueChanges.subscribe((val) => {
      if (val && val.name === 'Cash in hand') {
        this.getTransferToFund(1);   
      } else if (val && val.id) {
        this.getFund(undefined, 1, 1);
      }
    });

    this.bankTransferForm.get('transferTo')?.valueChanges.subscribe((val) => {
      if (val && val.name === 'Cash in hand') {
        this.getTransferToFund(2);  
      } else if (val && val.id) {
        this.getFund(undefined, 2, 2);
      }
    });

    this.triggerTransactionLogData
      .pipe(
        switchMap((data) => {
          return this.getTransferList().pipe(map(() => data));
        })
      )
      .subscribe((data) => {
        this.isBankImport = true;
        this.isCredit = data.isCredit;

        if (!data.isCredit) {
          const transferTo = this.findTransferItem(
            data.accountId,
            this.transferToGroupList
          );
          this.bankTransferForm.controls.transferTo.setValue(transferTo);
          this.bankTransferForm.controls.transferTo.disable();
        } else {
          const transferFrom = this.findTransferItem(
            data.accountId,
            this.transferFromGroupList
          );
          this.bankTransferForm.controls.transferFrom.setValue(transferFrom);
          this.bankTransferForm.controls.transferFrom.disable();
        }
      });

    this.triggerEditData
      .pipe(
        switchMap((data) => {
          return this.getTransferList().pipe(map(() => data));
        })
      )
      .subscribe((data) => {
        this.editBankTransfer(data);
      });

    this.bankTransferForm?.valueChanges?.subscribe((value) => {
      this.commonService.isInitialValueChange = this.bankTransferForm.touched;
    });
    this.setInvoiceDateLimits();
  }

  findTransferItem(accountId: any, transferGroupList: any[]): any {
    for (const items of transferGroupList) {
      const transferItem = items.listModels.find(
        (x: any) => x.id === accountId
      );
      if (transferItem) {
        return transferItem;
      }
    }
    return null;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  editBankTransfer(data): void {
    let transferFrom;
    this.transferFromGroupList.forEach((items) => {
      const transferFromId = items.listModels.find(
        (x: any) => x.id === data.transferredFromId
      );
      if (transferFromId !== null && transferFromId !== undefined) {
        transferFrom = transferFromId;
      
      }
    });

    let transferTo;
    this.transferToGroupList.forEach((items) => {
      const transferToId = items.listModels.find(
        (x: any) => x.id === data.transferredToId
      );
      if (transferToId !== null && transferToId !== undefined) {
        transferTo = transferToId;
       
      }
    });

    this.bankTransferForm.patchValue({
      bankTransferNumber: data.entryNumber,
      transferDate: data.entryDate,
      transferFrom: transferFrom,
      transferTo: transferTo,
      reference: data.note,
      amount: data.amount,
      fundId: data.fundId,
      fromfundId:data.fundFromID,
    });

    setTimeout(() => {
      this.getFund(data.fundFromID,1,1);
    }, 200);

    setTimeout(() => {
      this.getFund(data.fundId,2,2);
    }, 200);
    
  }

  resetAccountList(isFromTransfer: boolean): void {
    let data;
    if (isFromTransfer) {
      data = this.bankTransferForm.controls.transferFrom.value;
      this.transferFromGroupList = this.tempGroupList;
    } else {
      data = this.bankTransferForm.controls.transferTo.value;
      this.transferToGroupList = this.tempGroupList;
    }
   // this.scrollIntoView(data);
  }

  onAccountSearch(event: any, isFromTransfer: boolean): void {
    const list = this.commonService.onAccountSearch(event, this.tempGroupList);
    if (isFromTransfer) {
      this.transferFromGroupList = list;
    } else {
      this.transferToGroupList = list;
    }
  }

  getOptionText(option) {
    return option.name;
  }

  scrollIntoView(element) {
    if (element !== '') {
      this.commonService.autoScrollMatAutoComplete(this.renderer);
    }
  }

  gotoAddFund(type?:number): void {
    this.dialog
      .open(QuickAddComponent, {
        data: {
          moduleId: Modules.FundList,
          headerText: `Add ${ModuleName.Fund}`,
          saveActionName: CreateFund,
        },
      })
      .afterClosed()
      .subscribe((id) => {
        if (!this.commonService.isEmpty(id)) {
          this.disabledFundEditButton = false;
          this.getFund(id,type);
        }
      });
  }

  setForm(): void {
    this.bankTransferForm = new FormGroup(
      {
        bankTransferNumber: new FormControl('', Validators.required),
        transferDate: new FormControl(
          new Date(),
          datePickerValidator(this.periodicDate)
        ),
        transferFrom: new FormControl('', [Validators.required]),
        transferTo: new FormControl('', [Validators.required]),
        amount: new FormControl(''),
        reference: new FormControl('', [Validators.required]),
        fundId: new FormControl('', [Validators.required]),
        fromfundId: new FormControl('', [Validators.required]),
      },
      { validators: this.compareValidator('transferFrom', 'transferTo') }
    );

    this.bankTransferForm.controls.bankTransferNumber.disable();
    this.getTransferList().subscribe();
    //this.getFund();
  }

  compareValidator(transferFrom: string, transferTo: string): ValidatorFn {
    return (control: any): ValidationErrors | null => {
      const fromValue = control.get(transferFrom)?.value;
      const toValue = control.get(transferTo)?.value;

      if (!fromValue || !toValue) return null;

      const isSame = fromValue === toValue;

      if (isSame) {
        this.markControlsAsInvalid(control.controls, this.isBankImport, this.isCredit);
        return { matchingFields: true };
      }

      this.markControlsAsValid(control.controls, this.isBankImport, this.isCredit);
      return null;
    };
  }

  private markControlsAsInvalid(control, isImport, isCredit): void {
    if (isImport) {
      if (!isCredit) {
        control.transferFrom.status = 'INVALID';
        control.transferTo.status = 'DISABLED';
      } else {
        control.transferTo.status = 'INVALID';
        control.transferFrom.status = 'DISABLED';
      }
    } else {
      control.transferFrom.status = 'INVALID';
      control.transferTo.status = 'INVALID';
    }
  }

  private markControlsAsValid(control, isImport, isCredit): void {
    if (isImport) {
      if (!isCredit) {
        control.transferTo.status = 'DISABLED';
      } else {
        control.transferFrom.status = 'DISABLED';
      }
    } else {
      control.transferFrom.status = 'VALID';
      control.transferTo.status = 'VALID';
    }
  }

  getFund(id?: Guid,type?:number,num?:number): void {
    this.store
      .dispatch(new GetFundNameList())
      .pipe(
        tap((res) => {
          if(num === 1){
            this.bankTransferForm.controls.fromfundId.setValue(null);
            this.fundNameList = res?.account?.fundNameList || [];
          }else{
            this.bankTransferForm.controls.fundId.setValue(null);
            this.tofundNameList = res?.account?.fundNameList || [];
          }
          
         

          if (id !== null && id !== undefined) {
            if(type === 1){
              this.bankTransferForm.controls.fromfundId.setValue(id);
            }else{
              this.bankTransferForm.controls.fundId.setValue(id);
            }
          
          }
        })
      )
      .subscribe();
  }

  gotoEditFund(type:number): void {
    if (this.fundNameList.length > 0) {
      this.dialog
        .open(QuickAddComponent, {
          data: {
            moduleId: Modules.FundList,
            headerText: `Edit ${ModuleName.Fund}`,
            id: (type === 1)?(this.bankTransferForm.controls.fromfundId.value):this.bankTransferForm.controls.fundId.value,
            saveActionName: CreateFund,
            getActionName: GetDataByFundId,
          },
        })
        .afterClosed()
        .subscribe((id) => {
          if (!this.commonService.isEmpty(id)) {
            this.getFund(id,type);
          }
        });
    }
  }

  fundChange(event: any): void {
    if (event !== null && event !== undefined) {
      this.disabledFundEditButton = false;
    } else {
      this.disabledFundEditButton = true;
    }
  }

  getTransferList(): Observable<any> {
    return this.store.dispatch(new GetGroupCustomBankAndCashAccount()).pipe(
      tap((res) => {
        this.transferFromGroupList =
          res.common.customBankAndCashAccountGroupList;
        this.transferToGroupList = res.common.customBankAndCashAccountGroupList;

        this.tempGroupList = this.transferFromGroupList;
      })
    );
  }

  getTransferToFund(type: number): void {
    this.store
      .dispatch(new GetTransferToFund())
      .pipe(
        tap(() => {
          const response =
            this.store.selectSnapshot(FundTransferState.getTransferToFund) || [];

          if (type === 1) {
            this.fundNameList = response;
            this.bankTransferForm.controls.fromfundId.setValue(null);
          } else if (type === 2) {
            this.tofundNameList = response;
            this.bankTransferForm.controls.fundId.setValue(null);
          }
        })
      )
      .subscribe();
  }

  setInvoiceDateLimits(): void {
    if (this.periodicDate?.length > 0) {
      const unlockedPeriod = this.periodicDate.find(
        (period: any) => !period.isLocked
      );

      if (unlockedPeriod) {
        this.minInvoiceDate = new Date(unlockedPeriod.fromDate);
      } else {
        this.minInvoiceDate = new Date(this.periodicDate[0].fromDate);
      }

      this.maxInvoiceDate = new Date(
        this.periodicDate[this.periodicDate.length - 1]?.toDate
      );
    }
  }
}